import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { apiService } from '../../api/axiosClient'
import React, { Suspense, useState } from 'react'
import toast from 'react-hot-toast'
import ConfirmDialog from '../../utils/dialog'


const EventCard = React.lazy(() => import('./EventCard'));

const EventWrapper = ({ items, setItems }) => {
    const [open, setOpen] = useState(false);
    const [deleteItem, setDeleteItem] = useState(null);

    const handleConfirm = () => {
        setOpen(false);
        removeCard(deleteItem)
    };

    const handleClose = () => {
        setOpen(false);
    };

    const removeCard = async (item) => {
        try {
            await apiService.delete(`/events/${item.eventid}`)
            toast.success('이벤트가 삭제되었습니다.')

            setItems((items) => items.filter((k) => k.eventid !== item.eventid));
            setDeleteItem(null)

        } catch (error) {
            console.error(error)
        }
    }

    return (
        <Box>
            <Box sx={{ flexGrow: 1 }}>
                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
                    {items.map((item, index) => (
                        <Grid item xs={3} sm={3} md={3} key={index}>
                            <Suspense fallback={<div>Loading...</div>}>
                                <EventCard item={item} setOpen={setOpen} setDeleteItem={setDeleteItem} />
                            </Suspense>
                        </Grid>
                    ))}
                </Grid>
            </Box>
            <ConfirmDialog
                open={open}
                title={'이벤트 삭제'}
                content={`이벤트 ${deleteItem?.title} 를 삭제하시겠습니까?`}
                handleClose={handleClose}
                handleConfirm={handleConfirm}
            />
        </Box>
    )
}

export default EventWrapper